import React from "react";
import "./Home.css";
import Logos from "../Logos";

export const Home = () => {
  return (
    <div className="page-layout">
      <div className="text-layout">
        <h2>IEEE SmartComp 2025</h2>
        <p>
          International Conference on Smart Computing (SMARTCOMP) is the premier
          conference on smart computing. Smart computing is a multidisciplinary
          domain based on the synergistic influence of advances in sensor-based
          technologies, Internet of Things, cyber-physical systems, edge
          computing, big data analytics, machine learning, cognitive computing,
          and artificial intelligence.
        </p>
        <p>
          Applications of smart computing can be found in different societal
          domains including, but not limited to, transportation, energy,
          environmental protection, smart and connected communities, healthcare,
          banking, industrial systems, entertainment, and social media.
          Algorithmic and system advancements of cloud computing,
          mobile/pervasive computing, cyber-physical systems, sensor networking
          and social computing are taking smart computing to a new dimension and
          improving our ways of living.
        </p>
        <p>
          SMARTCOMP 2025 is the 11th edition of the conference and will be held
          at University College Cork and Munster Technological University, Cork,
          Ireland.
        </p>
        <p style={{ fontWeight: "bold", textAlign: "center" }}>
          *** Accepted Posters, Demos, and WIP papers will be published on IEEE
          Xplore! ***
        </p>
        <p>
          Extended versions of selected high quality SMARTCOMP 2025 papers will
          be invited for publication in{" "}
          <a href="https://www.sciencedirect.com/journal/pervasive-and-mobile-computing">
            Elsevier’s Journal of Pervasive and Mobile Computing.{" "}
          </a>
        </p>
        <hr />
        <h2>News</h2>
        <ul>
          <li>
            04 November 2024 - SmartComp 2025 will be held in Cork, Ireland from
            16 to 19 June 2025. See you there!
          </li>
        </ul>

        <hr />
        <h2>Important Dates</h2>
        <ul>
          <li>
            Main Conference Paper Submission:{" "}
            <span
              style={{ fontWeight: "bold", textDecoration: "line-through" }}
            >
              23rd February 2025
            </span>{" "}
            <span
              style={{
                fontWeight: "bold",
                color: "blue",
                textDecoration: "line-through",
              }}
            >
              9th March 2025
            </span>{" "}
            <span style={{ fontWeight: "bold", color: "red" }}>
              16th March 2025 (firm)
            </span>
          </li>
          <li>
            Workshop Proposal Submission:{" "}
            <span style={{ fontWeight: "bold" }}>15 December 2024</span>
          </li>
        </ul>
        <h2>Sponsors</h2>
        <div className="logo-container">
          <Logos />
        </div>
      </div>
    </div>
  );
};
